<script>
    import BrandProductBizz from "@xd/components/BrandProductBizz";
    import BrandProductBobby from "@xd/components/BrandProductBobby";
    import BrandProductCompact from "@xd/components/BrandProductCompact";
    import BrandProductDuffle from "@xd/components/BrandProductDuffle";
    import BrandProductElle from "@xd/components/BrandProductElle";
    import BrandProductFlexTrolley from "@xd/components/BrandProductFlexTrolley";
    import BrandProductGymBag from "@xd/components/BrandProductGymBag";
    import BrandProductHero from "@xd/components/BrandProductHero";
    import BrandProductPro from "@xd/components/BrandProductPro";
    import BrandProductSling from "@xd/components/BrandProductSling";
    import BrandProductSoft from "@xd/components/BrandProductSoft";
    import BrandProductSoftArt from "@xd/components/BrandProductSoftArt";
    import BrandProductTech from "@xd/components/BrandProductTech";
    import BrandProductTrolley from "@xd/components/BrandProductTrolley";
    import BrandProductUrban from "@xd/components/BrandProductUrban";
    import BrandProductUrbanBumbag from "@xd/components/BrandProductUrbanBumbag";
    import BrandProductUrbanLite from "@xd/components/BrandProductUrbanLite";
    import BrandProductXL from "@xd/components/BrandProductXL";
    import BrandProductBobbyExplore from "@xd/components/BrandProductBobbyExplore.vue";
    import BrandProductBizzV2 from "@xd/components/BrandProductBizzV2.vue";
    import BrandProductBoxySling from "@xd/components/BrandProductBoxySling.vue";
    import BrandProductBizzBackpack from "@xd/components/BrandProductBizzBackpack.vue";
    import BrandProductSoftDaypack from "@xd/components/BrandProductSoftDaypack.vue";
    import BrandProductEdge from "@xd/components/BrandProductEdge.vue";

    export default {
        name: "BrandProduct",
        components: {
            BrandProductBizz,
            BrandProductBobby,
            BrandProductCompact,
            BrandProductDuffle,
            BrandProductElle,
            BrandProductFlexTrolley,
            BrandProductGymBag,
            BrandProductHero,
            BrandProductPro,
            BrandProductSling,
            BrandProductSoft,
            BrandProductSoftArt,
            BrandProductTech,
            BrandProductTrolley,
            BrandProductUrban,
            BrandProductUrbanBumbag,
            BrandProductUrbanLite,
            BrandProductXL,
            BrandProductBobbyExplore,
            BrandProductBizzV2,
            BrandProductBoxySling,
            BrandProductBizzBackpack,
            BrandProductSoftDaypack,
            BrandProductEdge,
        },
        props: {
            product: Object,
            index: Number,
        },
        data() {
            return {
                visibleElements: [],
            };
        },
        computed: {
            componentName() {
                return "BrandProduct" + this.product.template;
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.startAnimation();
            });
        },
        methods: {
            startAnimation() {
                const elements = this.$refs.brandProduct.$el.querySelectorAll("[data-name]");

                const options = {
                    root: null,
                    rootMargin: "0px",
                    threshold: 0.15,
                };

                const observer = new IntersectionObserver((entries, observer) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const { name } = entry.target.dataset;
                            this.visibleElements.push(name);
                            observer.unobserve(entry.target);
                        }
                    });
                }, options);

                elements.forEach((element) => observer.observe(element));
            },
        },
    };
</script>

<template>
    <div class="brand-product-wrapper">
        <div
            class="brand-product__collider"
            :data-menu-index="index"
            :data-slug="product.slug"
            :data-year="product.year"
        />
        <component
            ref="brandProduct"
            :is="componentName"
            :product="product"
            :visible-elements="visibleElements"
        />
        <div
            class="brand-product__collider is-bottom"
            :data-menu-index="index"
            :data-slug="product.slug"
            :data-year="product.year"
        />
    </div>
</template>

<style lang="scss">
    .brand-product-wrapper {
        position: relative;
    }

    .brand-product {
        .l-container {
            overflow: visible;
            position: relative;
        }
    }

    .brand-product__header {
        @include bp($bp-desktop-lg) {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
        }
    }

    .brand-product__body {
        position: relative;
        z-index: 1;
    }

    .brand-product__title {
        margin-bottom: 14px;
        font-size: 30px;
        font-weight: 900;
        line-height: 21px;
        text-transform: uppercase;
        transition: opacity 1s ease-in-out;
        &.is-animated {
            opacity: 0;
        }
        @include bp($bp-desktop-lg) {
            margin-bottom: 0;
            font-size: 70px;
            font-weight: 900;
            line-height: 49px;
        }
    }

    .brand-product__text {
        font-size: 14px;
        font-weight: 300;
        line-height: 28px;
        transition: opacity 1.2s ease-in-out 0.6s;
        &.is-animated {
            opacity: 0;
        }
        @include bp($bp-desktop-lg) {
            font-size: 16px;
        }
    }

    .brand-product__date {
        font-size: 20px;
        font-weight: 300;
        line-height: 14px;
        text-transform: uppercase;
        transition: opacity 1s ease-in-out 0.3s;
        &.is-animated {
            opacity: 0;
        }
    }

    .brand-product__image {
        position: relative;
        width: 100%;
        flex-shrink: 0;
        &::before {
            content: "";
            display: block;
        }
    }

    .brand-product__year {
        position: absolute;
        user-select: none;
        pointer-events: none;
        transition: opacity 2.4s ease-in-out 0.2s, transform 1.2s ease-in-out 0.2s;
        img {
            animation: levitation 4.8s ease-in-out infinite 1.6s;
        }
        &.is-animated {
            opacity: 0;
            img {
                animation-play-state: paused;
            }
        }
    }

    .brand-product__collider {
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        right: 0;
        height: 70vh;
        opacity: 0;
        visibility: hidden;
        &.is-bottom {
            top: auto;
            bottom: 0;
            height: 50vh;
        }
    }

    .brand-product__line {
        position: absolute;
        animation: levitation ease-in-out infinite;
        animation-play-state: running;
        &.is-desktop {
            display: none;
        }
        &.is-animated {
            animation-play-state: paused;
        }
        @include bp($bp-desktop-lg) {
            &.is-mobile {
                display: none;
            }
            &.is-desktop {
                display: block;
            }
        }
    }

    .brand-product__blur,
    .brand-product__blur-mobile {
        position: absolute;
        transition: opacity 1.6s ease-in-out 0.3s;
        will-change: opacity;
        opacity: 1;
        &.is-animated {
            opacity: 0;
        }
        img {
            transform: scale(2);
        }
    }

    .brand-product__blur-mobile {
        @include bp($bp-desktop-lg) {
            display: none;
        }
    }
</style>
